export default "__VITE_ASSET__1322610b__"